import React, {useState} from "react";
import styles from './Header.module.css';
import {Col, Container, Nav, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import ListLogo from "../../images/list.svg";
import HeaderLogo from '../../images/walmart-pr.webp';

export function HeaderMobile() {

    const [showNavMobile, setShowNavMobile] = useState(false)
    const [showNavAuthMobile, setShowNavAuthMobile] = useState(false)

    const changeShowNavMobile = () => {
        setShowNavAuthMobile(false)
        setShowNavMobile(!showNavMobile)
    }

    return (
        <>
            <header className={`${styles.headerMobile} py-4`}>
                <Container>
                    <Row>
                        <Col sm={9} xs={9} className={`align-self-center justify-content-center text-center`}>
                        <a href="https://walmartpr.com">  
                        <img className={"img-fluid"} src={`${HeaderLogo}`}/> 
                        </a>
                        </Col>
                        <Col sm={1} xs={1} className={`align-self-center`}>
                            <div className={`justify-content-end`} onClick={changeShowNavMobile}>
                                <FontAwesomeIcon
                                    icon={showNavMobile ? solid('close') : solid('navicon')}
                                    color={`white`}
                                    size={"xl"}/>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </header>
            {showNavMobile ?
                <Nav className={`position-fixed flex-column w-100 ${styles.top100} ${styles.zIndex1}`}>
                    <Nav.Item>
                        <Nav.Link className={`${styles.navLink}`} href="https://walmartpr.com">
                            Inicio
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item key={`publicaciones`}>
                        <Nav.Link className={`${styles.navLink} ${styles.navLinkSelected}`} href="/publicaciones">
                            Publicaciones
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link className={`${styles.navLink}`} href="https://walmartpr.com/inspirate/">
                            ¡Inspírate!
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link className={`${styles.navLink}`} href="https://walmartpr.com/lo-ultimo/">Lo
                            último</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link className={`${styles.navLink}`}
                                  href="https://walmartpr.com/servicios/">Servicios</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link className={`${styles.navLink}`}
                                  href="https://walmartpr.com/asuntos-corporativos/">Corporativo</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link className={`${styles.navLink}`}
                                  href="https://walmartpr.com/tiendas/">Tiendas</Nav.Link>
                    </Nav.Item>
                </Nav> : null}
            {showNavAuthMobile ?
                <Nav
                    className={`position-fixed flex-column w-100 py-4 ${styles.top90} ${styles.zIndex1} ${styles.accountMenu}`}>
                    <Nav.Item className={`fs-6`}>
                        <Nav.Link className={`${styles.accountItem}`} href="/publicaciones/listas">
                            <span><img src={ListLogo} alt={`mis-listas`}/></span>
                            <span className={`mx-2`}>Mis listas</span>
                        </Nav.Link>
                    </Nav.Item>
                </Nav> : null}
        </>
    )
        ;
}


